import { FormattedMessage } from 'react-intl'
import { styled } from '@mui/material'
import { EditOutlined } from '@mui/icons-material'

import { useAppDispatch, useAppSelector } from 'app/state'
import HeaderSplitButton from 'features/common/ui/SplitButton/HeaderSplitButton'
import SharedMapSettingsPane from './SharedMapSettingsPane'

import PreferencesIcon from 'assets/icons/preferences.svg?react'
import { setPreviewMode } from 'features/builder/state/builderSlice'
import HeaderButton from 'features/common/ui/AppTemplate/Header/Partials/HeaderButton'
import { sendMetricEvent } from 'features/metrics/model/metricsMutations'
import { MetricEventType } from 'features/metrics/api/metrics'

const EditIcon = styled(EditOutlined)(({ theme }) => ({
  color: theme.palette.common.white
}))

function BuilderModeAndSettingsButton({ isPreviewMode }: { isPreviewMode: boolean }) {
  const dispatch = useAppDispatch()
  const mapId = useAppSelector((state) => state.maps.currentMap?.id)

  const onSwitchBuilderMode = () => {
    if (!mapId) return

    if (isPreviewMode) {
      sendMetricEvent(MetricEventType.MapEditMode, { mapId })
    } else {
      sendMetricEvent(MetricEventType.MapPreviewMode, { mapId })
    }
    dispatch(setPreviewMode(!isPreviewMode))
  }

  if (isPreviewMode) {
    return (
      <HeaderButton startIcon={<EditIcon />} variant="outlined" onClick={onSwitchBuilderMode}>
        <FormattedMessage id="builder.actions.edit" />
      </HeaderButton>
    )
  }
  return (
    <HeaderSplitButton
      variant="outlined"
      label={<FormattedMessage id="builder.actions.preview" />}
      onMainClick={onSwitchBuilderMode}
      icon={<PreferencesIcon />}
      MainButtonProps={{
        'aria-label': 'toggle-preview-mode',
        color: 'inherit'
      }}
      SecondButtonProps={{
        'aria-label': 'map-sharing-settings-menu',
        color: 'inherit'
      }}
    >
      {() => <SharedMapSettingsPane />}
    </HeaderSplitButton>
  )
}

export default BuilderModeAndSettingsButton
